import { Card, InlineGrid, InlineStack, Text } from "@shopify/polaris";

export const ExtensionsSupported = () => {
  const extensionsSupported = [
    { img: "https://cdn.keepcart.co/extension/ext-honey.png", name: "Honey" },
    { img: "https://cdn.keepcart.co/extension/ext-rakuten.png", name: "Rakuten" },
    { img: "https://cdn.keepcart.co/extension/ext-klarna.png", name: "Klarna" },
    { img: "https://cdn.keepcart.co/extension/ext-capitaloneshopping.png", name: "Capital One" },
    { img: "https://cdn.keepcart.co/extension/ext-karma.png", name: "Karma" },
    { img: "https://cdn.keepcart.co/extension/ext-coupert.png", name: "Coupert" },
    { img: "https://cdn.keepcart.co/extension/ext-retailmenot.png", name: "Retailmenot" },
    { img: "https://cdn.keepcart.co/extension/ext-swagbucks.png", name: "Swagbucks" },
    { img: "https://cdn.keepcart.co/extension/ext-ibotta.png", name: "Ibotta" },
    { img: "https://cdn.keepcart.co/extension/ext-mino.png", name: "Mino" },
    // { name: "Pie", img: "https://cdn.keepcart.co/extension/ext-pie.png" },
    { img: "https://cdn.keepcart.co/extension/ext-cashrewards.png", name: "Cashrewards" },
    { img: "https://cdn.keepcart.co/extension/ext-vouchercodes.png", name: "Vouchercodes" },
    { img: "https://cdn.keepcart.co/extension/ext-couoncabin.png", name: "Couponcabin" },
    { img: "https://cdn.keepcart.co/extension/ext-simplycodes.png", name: "Simplycodes" },
    { img: "https://cdn.keepcart.co/extension/ext-bestprice.png", name: "Bestprice.com" },
    //{ name: "Couponbird", img: "https://cdn.keepcart.co/extension/ext-couponbird.png" },
    { img: "https://cdn.keepcart.co/extension/ext-couonbind.png", name: "Couponbind" },
    { img: "https://cdn.keepcart.co/extension/ext-dontpayfull.png", name: "Dontpayfull" },
    { img: "https://cdn.keepcart.co/extension/ext-mojo.png", name: "Mojo" },
    { img: "https://cdn.keepcart.co/extension/ext-cashbackeasy.png", name: "Cashback Easy" },
    { img: "https://cdn.keepcart.co/extension/ext-savings.com.png", name: "Savings.com" },
    { img: "https://cdn.keepcart.co/extension/ext-revount.png", name: "Revount" },
    { img: "https://cdn.keepcart.co/extension/ext-ruby.png", name: "Ruby" },
    { img: "https://cdn.keepcart.co/extension/ext-shoppsie.png", name: "Shoppsie" },

    //{ name: "Couponbirds", img: "https://cdn.keepcart.co/extension/ext-couponbirds.png" },
    { img: "https://cdn.keepcart.co/extension/ext-slickdeals.png", name: "Slickdeals" },
    { img: "https://cdn.keepcart.co/extension/ext-befrugal.png", name: "Befrugal" },
    { img: "https://cdn.keepcart.co/extension/ext-pouch.png", name: "Pouch" },
    // { name: "Topcashback", img: "https://cdn.keepcart.co/extension/ext-topcashback.png" },
    { img: "https://cdn.keepcart.co/extension/ext-cently.png", name: "Cently" },
    { img: "https://cdn.keepcart.co/extension/ext-hotukdeals.png", name: "Hotukdeals" },
    { img: "https://cdn.keepcart.co/extension/ext-fatcoupon.png", name: "Fatcoupon" },
    { img: "https://cdn.keepcart.co/extension/ext-moolah.png", name: "Moolah" },
    { img: "https://cdn.keepcart.co/extension/ext-dealdrop.png", name: "Dealdrop" },
    //{ name: "Checkmate", img: "https://cdn.keepcart.co/extension/ext-checkmate.png" },
    { img: "https://cdn.keepcart.co/extension/ext-shopmail.png", name: "Shopmail" },
    // { name: "Codes.co.uk", img: "https://cdn.keepcart.co/extension/ext-codes.co.uk.png" },
    { img: "https://cdn.keepcart.co/extension/ext-hoopla.png", name: "Hoopla" },
    { img: "https://cdn.keepcart.co/extension/ext-offerslove.png", name: "Offerslove" },
    { img: "https://cdn.keepcart.co/extension/ext-dealmela.png", name: "Dealmela" },
    { img: "https://cdn.keepcart.co/extension/ext-coupongini.png", name: "Coupongini" },
    //{ name: "Oohcoupons", img: "https://cdn.keepcart.co/extension/ext-oohcoupons.png" },
  ];

  return (
    <InlineGrid columns={3} gap="300">
      {extensionsSupported.map((extension) => (
        <ExtensionCard key={extension.name} {...extension} />
      ))}
    </InlineGrid>
  );
};

interface ExtensionCardProps {
  img: string;
  name: string;
}

const ExtensionCard = ({ img, name }: ExtensionCardProps) => {
  return (
    <Card padding="200">
      <InlineStack blockAlign="center" gap="400">
        <img alt={name} src={img} style={{ borderRadius: "8px", height: "2.5rem", width: "2.5rem" }} />
        <Text as="p" variant="bodyLg">
          {name}
        </Text>
      </InlineStack>
    </Card>
  );
};
